import { useContext } from 'react';
import HistoryContext, { HistoryState } from './Context';

const useHistory = (): HistoryState => useContext(HistoryContext);

export default useHistory;
